/**
 * TrackingProvider
 * Activates page view and click tracking globally
 * Must be rendered inside BrowserRouter
 */

import { usePageTracking } from '@/hooks/usePageTracking';
import { useClickTracking } from '@/hooks/useClickTracking';

export function TrackingProvider(): null {
  usePageTracking();
  useClickTracking();
  return null;
}
